import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import ReactHtmlParser from 'react-html-parser';
import { BASE } from '../api/api'
import Axios from 'axios';
import { List } from 'react-content-loader'

let url = window.location.href;
let url_string = url;
let urlStr = new URL(url_string);
let c = urlStr.searchParams.get("key");

class NewsOpen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      news: '',
      newsimg: ''
    }
  }
  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    // window.location.href = '/'

  }


  refreshexp(){
    let s = new Date();
    s.setSeconds(s.getSeconds()+1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry(){
    if(localStorage.getItem('expiryref')){
      let expref=Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if(s>expref){
          this.signout()
      }
      else{
        this.refreshexp()
      }
      
    }
    else{
      this.signout()  
  }
  }


  componentWillMount() {
    
    let url = window.location.href;
    let url_string = url;
    let urlStr = new URL(url_string);
    let c = urlStr.searchParams.get("key");
    let nid = urlStr.searchParams.get("nid");
    this.topFunction()
    Axios.get(BASE + '/jsonapi/node/news?include=field_source&filter[drupal_internal__nid]=' + nid)
      .then((data) => {
        if(localStorage.getItem('token'))
        this.checkexpiry()
        this.setState({
          news: data.data.data[0],
          newsimg: data.data.data[0].relationships.field_source.data != null ? BASE + data.data.included[0].attributes.uri.url : ''
        })
      })
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  render() {
    return (
      <div className='peoplewiki newsopen'>
        <Header />
        <body className="wiki" >
          <div className="main-content">
            <div className="container">
              <div className="row">
                <div className="node-wiki node">
                  {this.state.newsimg ?
                    <div className="group-left">
                      <div className="field-name-field-thumbnail">
                        <img src={this.state.newsimg} width="70" height="70" />
                      </div>
                    </div> : ''}
                  {this.state.news ? <div style={{ width: this.state.newsimg ? '' : '100%' }} className="group-middle">
                    <div className="field-name-title">
                      <div className='booktitle_rea'>{this.state.news.attributes.title}</div>
                    </div>
                    <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                      <div className="field-items">
                        <div className="field-item even" property="content:encoded">
                          {ReactHtmlParser(this.state.news.attributes.body ? this.state.news.attributes.body.processed : '')}
                        </div>
                      </div>
                    </div>
                  </div> : <List />}
                </div>
              </div>
            </div>
          </div>
        </body>
        <div>
          <Footer />
        </div>
      </div>
    )


  }

}

export default NewsOpen;
